import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerProClub.scss';
import '../assets/css/partnerPortal/welcome.scss';
import '../assets/css/partnerPortal/homepage.scss';

import chevronDown from '../assets/img/partnerPortal/welcomePage/chevron-down.png';
import chevronUp from '../assets/img/partnerPortal/welcomePage/chevron-up.png'; 


function NewsSectionTwo(props) {

    const [active, setActive] = useState(props.active || false);
    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);

    function openModel() {
        setActive(!active);
    }

    return (

        <>
        <div className="faqBodyRow ">
            <div className="d-flex align-items-center width66 clickable screenChange " onClick={openModel}>
                <div className="d-flex align-items-start flex-column width90">
                    <div className="faqBodyHeader" >{title} </div>
                </div>
                {active ? <img className="align-items-end" src={chevronUp} alt='...'  /> :<img className="align-items-end" src={chevronDown} alt='...'  />}
            </div>
            
        </div>
        
        <div className="d-block align-items-center width66 screenChange">
            <div className="d-flex align-items-start flex-column width90">
                <div className={"faqBodyText " + (active ? "d-flex" : "d-none") }>   
                {subTitle}
                </div>
            </div>
        </div>
        <div className="width66">
            <div className="lineBlack d-flex align-items-start mt-4 mb-4 width91"></div>
        </div>
        </>

    )


}

export default withRouter(NewsSectionTwo);



